// ** Types Import
import { Settings } from 'src/@core/context/settingsContext';
import { NavLink, NavGroup, NavSectionTitle, VerticalNavItemsType } from 'src/@core/layouts/types';

// ** Custom Menu Components
import VerticalNavLink from './VerticalNavLink';
import VerticalNavGroup from './VerticalNavGroup';
import VerticalNavSectionTitle from './VerticalNavSectionTitle';
import ImportFailureNavLink from './custom/ImportFailureNavLink';

export interface Props {
  parent?: NavGroup;
  navHover?: boolean;
  settings: Settings;
  navVisible?: boolean;
  groupActive: string[];
  isSubToSub?: NavGroup;
  currentActiveGroup: string[];
  navigationBorderWidth: number;
  verticalNavItems?: VerticalNavItemsType;
  saveSettings: (values: Settings) => void;
  setGroupActive: (value: string[]) => void;
  setCurrentActiveGroup: (item: string[]) => void;
}

const resolveNavItemComponent = (item: NavGroup | NavLink | NavSectionTitle) => {
  if ((item as NavSectionTitle).sectionTitle) return VerticalNavSectionTitle;
  if ((item as NavGroup).children && (item as NavGroup).children!.length > 0) return VerticalNavGroup;

  return VerticalNavLink;
};

const getNavItemKey = (item: NavGroup | NavLink | NavSectionTitle, index: number) => {
  const anyItem = item as any;

  if (anyItem.id) return `id-${anyItem.id}`;
  if ((item as NavLink).path) return `path-${(item as NavLink).path}`;
  if ((item as NavSectionTitle).sectionTitle) return `section-${(item as NavSectionTitle).sectionTitle}`;
  if (anyItem.title) return `title-${anyItem.title}-${index}`;

  return `item-${index}`;
};

const VerticalNavItems = (props: Props) => {
  // ** Props
  const { verticalNavItems } = props;

  const RenderMenuItems =
    verticalNavItems?.map((item: NavGroup | NavLink | NavSectionTitle, index: number) => {
      const key = getNavItemKey(item, index);

      if ((item as any).menuItemComponentCode === 'IMPORTFAILURES') {
        return <ImportFailureNavLink {...props} props={{ ...props }} key={key} item={item} />;
      }

      const TagName: any = resolveNavItemComponent(item);

      return <TagName {...props} key={key} item={item} />;
    }) ?? [];

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{RenderMenuItems}</>;
};

export default VerticalNavItems;
